import { render } from "./MarketTemplateDetails.vue?vue&type=template&id=609a8242&scoped=true"
import script from "./MarketTemplateDetails.vue?vue&type=script&lang=js"
export * from "./MarketTemplateDetails.vue?vue&type=script&lang=js"

import "./MarketTemplateDetails.vue?vue&type=style&index=0&id=609a8242&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609a8242"]])

export default __exports__